export default __webpack_public_path__ + "static/media/react.949f5be0.svg";